<script setup>
/**
 * ReportsMock — the reports center as crisp vector UI: data sources,
 * filters hint, output formats. Mirrors the real screen. Decorative.
 */
const SOURCES = [
  { name: 'Participants', desc: 'Listes, check-in, statuts VIP', bg: '#6d4fc2', on: true },
  { name: 'Activités', desc: 'Scores, votes, taux de participation', bg: '#e84393', on: true },
  { name: 'Programme', desc: 'Agenda, salles et capacités', bg: '#00b894', on: false },
  { name: 'Intervenants', desc: 'Biographies, sessions, documents', bg: '#e8a34d', on: false }
]
</script>

<template>
  <div class="bg-white" aria-hidden="true">
    <div class="px-5 pt-4 pb-3 border-b border-slate-100 flex items-center justify-between gap-3">
      <div>
        <div class="text-[15px] font-semibold text-slate-900">Centre de rapports</div>
        <div class="text-[11px] text-slate-400">Extraction de données et synthèses</div>
      </div>
      <div class="flex text-[11px] rounded-lg border border-slate-200 overflow-hidden">
        <span class="px-3 py-1.5 bg-slate-100 text-slate-800 font-medium">Données</span>
        <span class="px-3 py-1.5 text-slate-400">Intelligent Insights</span>
      </div>
    </div>

    <div class="grid sm:grid-cols-[1.5fr_1fr]">
      <div class="p-4 grid grid-cols-2 gap-2.5">
        <div v-for="(s, i) in SOURCES" :key="i"
          class="rounded-xl border p-3" :class="s.on ? 'border-[#6d4fc2]/50 bg-[#6d4fc2]/[0.04]' : 'border-slate-200'">
          <div class="flex items-start justify-between mb-2">
            <span class="w-7 h-7 rounded-lg" :style="`background:${s.bg}1f; border:1px solid ${s.bg}55`"></span>
            <span v-if="s.on" class="w-4 h-4 rounded-full bg-[#6d4fc2] text-white text-[9px] flex items-center justify-center">✓</span>
          </div>
          <div class="text-[12px] font-semibold text-slate-900">{{ s.name }}</div>
          <div class="text-[10px] text-slate-400 leading-snug mt-0.5">{{ s.desc }}</div>
        </div>
      </div>

      <div class="border-s border-slate-100 p-4">
        <div class="text-[10px] font-medium uppercase tracking-wider text-slate-400 mb-2">Filtres</div>
        <div class="space-y-1.5 mb-4">
          <div class="flex items-center gap-2 text-[11px] text-slate-600">
            <span class="w-3.5 h-3.5 rounded bg-[#6d4fc2] text-white text-[8px] flex items-center justify-center">✓</span> VIP
          </div>
          <div class="flex items-center gap-2 text-[11px] text-slate-600">
            <span class="w-3.5 h-3.5 rounded bg-[#6d4fc2] text-white text-[8px] flex items-center justify-center">✓</span> Standard
          </div>
          <div class="flex items-center gap-2 text-[11px] text-slate-600">
            <span class="w-3.5 h-3.5 rounded border border-slate-300"></span> Intervenants
          </div>
        </div>
        <div class="text-[10px] font-medium uppercase tracking-wider text-slate-400 mb-2">Format de sortie</div>
        <div class="flex gap-1.5 mb-4">
          <span class="text-[10px] font-mono border border-[#6d4fc2] text-[#6d4fc2] rounded-md px-2 py-1">XLSX</span>
          <span class="text-[10px] font-mono border border-slate-200 text-slate-400 rounded-md px-2 py-1">CSV</span>
          <span class="text-[10px] font-mono border border-slate-200 text-slate-400 rounded-md px-2 py-1">PDF</span>
        </div>
        <span class="block text-center bg-[#6d4fc2] text-white rounded-md px-3 py-2 text-[11px] font-medium">Générer le rapport</span>
        <div class="mt-2.5 text-[10px] text-slate-400 text-center">Généré en tâche de fond · notification à la fin</div>
      </div>
    </div>
  </div>
</template>
